<h1 class="accent-background-element">History Log</h1>

<mat-dialog-content>
  @if ((this.loadingSubject | async); as loading) {
    <div class="spinner-container">
      <mat-spinner color="accent" [diameter]="30" class="spinner-diametser-30"></mat-spinner>
    </div>
  }
  @if (!isENT) {
    <div>
      @if ((this.loadingSubject | async) === false) {
        <div>
          @if ((this.logClinicSubject | async)===null) {
            <p class="no-info">
              No Log information available for this Clinic/Office.
            </p>
          }
        </div>
      }
      @if ((this.loadingSubject | async) === false) {
        <div>
          @if ((this.logClinicSubject | async); as log) {
            <div>
              @for (item of log.auditTrail.history; track item) {
                <div>
                  <p class="flex"><b>Action:</b>&nbsp;@if (item.action) {
                  <span
                  >{{item.action|titlecase}}</span>
                } @else {
                  <mat-icon svgIcon='dash'></mat-icon>
                }
              </p>
              <p class="flex"><b>Time:</b>&nbsp;@if (item.timestamp) {
              <span
                >{{item.timestamp | date:
              'yyyy-MM-dd HH:mm:SS'}}</span>
            } @else {
              <mat-icon svgIcon='dash'></mat-icon>
            }</p>
            <p class="flex"><b>User ID:</b>&nbsp;@if (item.userId) {
            <span
            >{{item.userId}}</span>
          } @else {
            <mat-icon svgIcon='dash'></mat-icon>
          }</p>
          <p class="flex"><b>User Data:</b>&nbsp;@if (item.userData) {
          <span
          >{{item.userData}}</span>
        } @else {
          <mat-icon svgIcon='dash'></mat-icon>
        }</p>
        <p class="flex"><b>Reason:</b>&nbsp;@if (item.reason) {
        <span
        >{{item.reason}}</span>
      } @else {
        <mat-icon svgIcon='dash'></mat-icon>
      }</p>
      <p class="flex"><b>Approved:</b>&nbsp;<span>{{item.approved? 'Yes':'No'}}</span>
    </p>
    <div><b>Item:</b>&nbsp;
    @if (item.item; as clinic) {
      <div class="not-bold item-info">
        <p class="flex"><b>Clinic ID:</b>&nbsp;@if (clinic.shopId) {
        <span
        >{{clinic.shopId}}</span>
      } @else {
        <mat-icon svgIcon='dash'></mat-icon>
      }
    </p>
    <p class="flex"><b>Clinic Name:</b>&nbsp;@if (clinic.shopName) {
    <span
    >{{clinic.shopName}}</span>
  } @else {
    <mat-icon svgIcon='dash'></mat-icon>
  }
</p>
<p class="flex"><b>Country:</b>&nbsp;@if (clinic.country) {
<span
>{{clinic.country}}</span>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</p>
@if (clinic.country.toString() == 'US') {
  <p class="flex">
    <b>State:</b>&nbsp;@if (clinic.state) {
    <span
    >{{getStateName(clinic.state)}}</span>
  } @else {
    <mat-icon svgIcon='dash'></mat-icon>
  }
</p>
}
<p class="flex"><b>City:</b>&nbsp;@if (clinic.city) {
<span
>{{clinic.city}}</span>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</p>
<p class="flex"><b>Address Line 1:</b>&nbsp;@if (clinic.addressLine1) {
<span
>{{clinic.addressLine1}}</span>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</p>
<p class="flex"><b>Address Line 2:</b>&nbsp;@if (clinic.addressLine2) {
<span
>{{clinic.addressLine2}}</span>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</p>
<p class="flex"><b>Brand ID:</b>&nbsp;@if (clinic.brandId) {
<span
>{{getBrandName(clinic.brandId)}}</span>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</p>
<p class="flex"><b>Phone:</b>&nbsp;@if (clinic.phone) {
<span
>{{clinic.phone}}</span>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</p>
<p class="flex"><b>E-mail:</b>&nbsp;@if (clinic.email) {
<span
>{{clinic.email}}</span>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</p>
<p class="flex"><b>Shop Type:</b>&nbsp;@if (clinic.shopType) {
<span
>{{clinic.shopType}}</span>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</p>
<p class="flex"><b>Presented for
selection:</b>&nbsp;<span>{{clinic.presentedForSelection?
'Yes':'No'}}</span>
</p>
<p><b>Coordinates (Apple Maps):</b>&nbsp;
<span>{{clinic.appleMaps.geolocation.latitude}},
{{clinic.appleMaps.geolocation.longitude}}</span>
</p>
<p><b>Coordinates (Google Maps):</b>&nbsp;
<span>{{clinic.googleMaps.geolocation.latitude}},
{{clinic.googleMaps.geolocation.longitude}}</span>
</p>
<p><b>Opening Hours: </b></p>
<div class="hours">
  <p><b>Monday:</b>&nbsp; <span>{{(clinic.openingHours
  &&clinic.openingHours![0].length>0) ?
clinic.openingHours![0]:"Closed"}}</span>
</p>
<p><b>Tuesday:</b>&nbsp; <span>{{(clinic.openingHours
&&clinic.openingHours![1].length>0) ?
clinic.openingHours![1]:"Closed"}}</span>
</p>
<p><b>Wednesday:</b>&nbsp; <span>{{(clinic.openingHours
&&clinic.openingHours![2].length>0) ?
clinic.openingHours![2]:"Closed"}}</span>
</p>
<p><b>Thursday:</b>&nbsp; <span>{{(clinic.openingHours
&&clinic.openingHours![3].length>0) ?
clinic.openingHours![3]:"Closed"}}</span>
</p>
<p><b>Friday:</b>&nbsp; <span>{{(clinic.openingHours
&&clinic.openingHours![4].length>0) ?
clinic.openingHours![4]:"Closed"}}</span>
</p>
<p><b>Saturday:</b>&nbsp; <span>{{(clinic.openingHours
&&clinic.openingHours![5].length>0) ?
clinic.openingHours![5]:"Closed"}}</span>
</p>
<p><b>Sunday:</b>&nbsp; <span>{{(clinic.openingHours
&&clinic.openingHours![6].length>0) ?
clinic.openingHours![6]:"Closed"}}</span>
</p>
</div>
</div>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
<mat-divider></mat-divider>
</div>
</div>
}
</div>
}
</div>
}
</div>
}
@if (isENT) {
  <div>
    @if ((this.loadingSubject | async) === false) {
      <div>
        @if ((this.logOfficeSubject | async)===null) {
          <p class="no-info">
            No Log information available for this Clinic/Office.
          </p>
        }
      </div>
    }
    @if ((this.loadingSubject | async) === false) {
      <div>
        @if ((this.logOfficeSubject | async); as log) {
          <div>
            @for (item of log.auditTrail.history; track item) {
              <div>
                <p class="flex"><b>Action:</b>&nbsp;@if (item.action) {
                <span
                >{{item.action|titlecase}}</span>
              } @else {
                <mat-icon svgIcon='dash'></mat-icon>
              }
            </p>
            <p class="flex"><b>Time:</b>&nbsp;@if (item.timestamp) {
            <span
              >{{item.timestamp |
              date:
            'yyyy-MM-dd HH:mm:SS'}}</span>
          } @else {
            <mat-icon svgIcon='dash'></mat-icon>
          }</p>
          <p class="flex"><b>User ID:</b>&nbsp;@if (item.userId) {
          <span
          >{{item.userId}}</span>
        } @else {
          <mat-icon svgIcon='dash'></mat-icon>
        }
      </p>
      <p class="flex"><b>User Data:</b>&nbsp;@if (item.userData) {
      <span
      >{{item.userData}}</span>
    } @else {
      <mat-icon svgIcon='dash'></mat-icon>
    }</p>
    <p class="flex"><b>Reason:</b>&nbsp;@if (item.reason) {
    <span
    >{{item.reason}}</span>
  } @else {
    <mat-icon svgIcon='dash'></mat-icon>
  }
</p>
<p class="flex"><b>Approved:</b>&nbsp;<span>{{item.approved? 'Yes':'No'}}</span>
</p>
<div><b>Item:</b>&nbsp;
@if (item.item; as office) {
  <div class="not-bold item-info">
    <p class="flex"><b>Office ID:</b>&nbsp;@if (office.id) {
    <span
    >{{office.id}}</span>
  } @else {
    <mat-icon svgIcon='dash'></mat-icon>
  }
</p>
<p class="flex"><b>Office Name:</b>&nbsp;@if (office.entOfficeName) {
<span
>{{office.entOfficeName}}</span>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</p>
<p class="flex"><b>Country:</b>&nbsp;@if (office.country) {
<span
>{{office.country}}</span>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</p>
@if (office.country.toString() == 'US') {
  <p class="flex">
    <b>State:</b>&nbsp;@if (office.state) {
    <span
    >{{office.state}}</span>
  } @else {
    <mat-icon svgIcon='dash'></mat-icon>
  }
</p>
}
<p class="flex"><b>City:</b>&nbsp;@if (office.city) {
<span
>{{office.city}}</span>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</p>
<p class="flex"><b>Address Line 1:</b>&nbsp;@if (office.addressLine1) {
<span
>{{office.addressLine1}}</span>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</p>
<p class="flex"><b>Address Line 2:</b>&nbsp;@if (office.addressLine2) {
<span
>{{office.addressLine2}}</span>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</p>
<p class="flex"><b>Phone:</b>&nbsp;@if (office.phone) {
<span
>{{office.phone}}</span>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</p>
<p class="flex"><b>Website:</b>&nbsp;@if (office.webpage) {
<span
>{{office.webpage}}</span>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</p>
<p class="flex"><b>E-mail:</b>&nbsp;@if (office.email) {
<span
>{{office.email}}</span>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</p>
<p class="flex"><b>Presented for selection:</b>&nbsp;<span>{{!office.hidden?
'Yes':'No'}}</span>
<p><b>Coordinates (Apple Maps):</b>&nbsp;
<span>{{office.appleMaps.geolocation.latitude}},
{{office.appleMaps.geolocation.longitude}}</span>
</p>
<p><b>Coordinates (Google Maps):</b>&nbsp;
<span>{{office.googleMaps.geolocation.latitude}},
{{office.googleMaps.geolocation.longitude}}</span>
</p>
<p><b>ENT Doctors: </b></p>
@if (office.doctors && office.doctors!.length>0) {
  <div class="doctors">
    @for (doctor of office.doctors; track doctor; let i = $index) {
      <p>
        {{i+1}}.&nbsp;{{doctor}}
      </p>
    }
  </div>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
</div>
} @else {
  <mat-icon svgIcon='dash'></mat-icon>
}
<mat-divider></mat-divider>
</div>
</div>
}
</div>
}
</div>
}
</div>
}

</mat-dialog-content>



